import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
} from '@tencentcloud/chat-uikit-engine';
import { ref } from '../../../../adapter-vue';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import fileIcon from '../../../../assets/icon/files.png';
import { isPC, isUniFrameWork } from '../../../../utils/env';
import { isEnabledMessageReadReceiptGlobal } from '../../utils/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const inputRef = ref();
const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onIconClick = () => {
  if (isUniFrameWork) {
    return;
  } else {
    inputRef?.value?.click && inputRef?.value?.click();
  }
};

const sendFileMessage = (e: any) => {
  if (e?.target?.files?.length <= 0) {
    return;
  }
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID
      || currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload: {
      file: e?.target,
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  TUIChatService.sendFileMessage(options);
  e.target.value = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolbarItemContainer, {
    iconFile: _unref(fileIcon),
    title: "文件",
    iconWidth: _unref(isUniFrameWork) ? '32px' : '21px',
    iconHeight: _unref(isUniFrameWork) ? '25px' : '18px',
    needDialog: false,
    onOnIconClick: onIconClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['file-upload', !_unref(isPC) && 'file-upload-h5'])
      }, [
        _createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          title: "文件",
          type: "file",
          "data-type": "file",
          accept: "*",
          onChange: sendFileMessage
        }, null, 544)
      ], 2)
    ]),
    _: 1
  }, 8, ["iconFile", "iconWidth", "iconHeight"]))
}
}

})